import React from 'react';
import _isEmpty from 'lodash/isEmpty';

export default function RecommendationTabs({
  recommendCategory,
  index,
  setIndex,
}) {
  return (
    <div className="skincaredetectionpreview-results__recommends">
      {!_isEmpty(recommendCategory) &&
        recommendCategory
          .filter(r => !r.disabled)
          .map(s => (
            <div
              className="text-center"
              style={{
                flex: `0 0 calc(${100 /
                  recommendCategory.filter(r => !r.disabled).length}% - 1px)`,
                color: index === s.value ? '#fff' : '#333333',
                backgroundColor:
                  index === s.value
                    ? 'rgba(0, 0, 0, 0.4)'
                    : 'rgba(216, 223, 248, 0.4)',
              }}
              onClick={() => {
                setIndex(s.value);
              }}
            >
              {s.label}
            </div>
          ))}
    </div>
  );
}
